import React from "react";
import "./getADemo.scss";
import { GetADemoForm } from "./GetADemoForm";

import { CheckCircleOutlined } from "@ant-design/icons";

export function GetADemoPage(props) {
  return (
    <>
      <section className="getADemoPageContainer">
        <div className="getADemoPageContentContainer">
          <div className="getADemoPageTextContainer">
            <h4 className="smallSUbhead">Contact Sales</h4>
            <h1 className="largeHeadline mb-4">Request a Demo</h1>

            <div className="checkmarkItem">
              <CheckCircleOutlined style={{ fontSize: 24, color: "#8cc640" }} />
              <p className="bodyText">
                Explore how the platform helps teams address challenges like
                capacity planning, project profitability, client profitability,
                and team productivity.
              </p>
            </div>

            <div className="checkmarkItem">
              <CheckCircleOutlined style={{ fontSize: 24, color: "#8cc640" }} />
              <p className="bodyText">
                Get custom solutions and onboarding support tailored to your
                team's unique needs.
              </p>
            </div>

            <div className="checkmarkItem">
              <CheckCircleOutlined style={{ fontSize: 24, color: "#8cc640" }} />
              <p className="bodyText">
                Discover seamless methods for integrating this tool into your
                team's daily workflow with minimal disruption.
              </p>
            </div>

            <div className="checkmarkItem">
              <CheckCircleOutlined style={{ fontSize: 24, color: "#8cc640" }} />
              <p className="bodyText">
                Explore custom pricing options ideal for medium to large-sized
                teams.
              </p>
            </div>
          </div>
          <div className="getADemoPageFormContainer">
            <GetADemoForm />
          </div>
        </div>
      </section>
    </>
  );
}
